import PropTypes from 'prop-types'

import { Box, Icon } from '@redriverpress/system'

import { resultImageSize } from '../../constants/ui'

export default function ImagePlaceholder({ size, icon }) {
  return (
    <Box
      size={size}
      borderRadius='circular'
      bg='gray150'
      display='flex'
      alignItems='center'
      justifyContent='center'
      mx='auto'
    >
      <Icon icon={icon} fontSize={3} color='gray700' />
    </Box>
  )
}

ImagePlaceholder.defaultProps = {
  size: resultImageSize,
  icon: 'images',
}

ImagePlaceholder.propTypes = {
  icon: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
}
